import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-501e3174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row py-5" }
const _hoisted_2 = { class: "pagination-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: 
          _ctx.showPerPage
            ? 'total, prev, pager, next, sizes'
            : 'total, prev, pager, next'
        ,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "page-size": _ctx.pageSize,
        "page-sizes": [10, 30, 50, 100, 150],
        onCurrentChange: _ctx.change,
        onSizeChange: _ctx.changePageSize
      }, null, 8, ["layout", "current-page", "total", "page-size", "onCurrentChange", "onSizeChange"])
    ])
  ]))
}